var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65 5.6H9.35V4H7.65M8.5 14.4C4.7515 14.4 1.7 11.528 1.7 8C1.7 4.472 4.7515 1.6 8.5 1.6C12.2485 1.6 15.3 4.472 15.3 8C15.3 11.528 12.2485 14.4 8.5 14.4ZM8.5 0C7.38376 0 6.27846 0.206926 5.24719 0.608964C4.21592 1.011 3.27889 1.60028 2.48959 2.34315C0.895533 3.84344 0 5.87827 0 8C0 10.1217 0.895533 12.1566 2.48959 13.6569C3.27889 14.3997 4.21592 14.989 5.24719 15.391C6.27846 15.7931 7.38376 16 8.5 16C10.7543 16 12.9163 15.1571 14.5104 13.6569C16.1045 12.1566 17 10.1217 17 8C17 6.94943 16.7801 5.90914 16.353 4.93853C15.9258 3.96793 15.2997 3.08601 14.5104 2.34315C13.7211 1.60028 12.7841 1.011 11.7528 0.608964C10.7215 0.206926 9.61624 0 8.5 0ZM7.65 12H9.35V7.2H7.65V12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.ced9e8f1.svg";
export { ForwardRef as ReactComponent };